/* tslint:disable:max-line-length */
import * as React from 'react'

export const UI = {
  personColored: (
    <>
      <defs>
        <clipPath clipPathUnits="userSpaceOnUse" id="cp1">
          <path d="M94.77 269.15L475.12 269.15L475.12 507.13L94.77 507.13L94.77 269.15Z" />
        </clipPath>
      </defs>
      <g>
        <path
          fillRule="evenodd"
          fill="#91d1da"
          d="M289.89 269.15L280.01 269.15C220.62 269.15 172.03 220.51 172.03 161.06L172.03 115.47C172.03 56.02 220.62 7.38 280.01 7.38L289.89 7.38C349.28 7.38 397.87 56.02 397.87 115.47L397.87 161.06C397.87 220.51 349.28 269.15 289.89 269.15Z"
        />
        <g>
          <g clipPath="url(#cp1)">
            <path
              fillRule="evenodd"
              fill="#0142f1"
              d="M475.12 507.13L475.12 352.44C475.12 352.44 475.12 304.85 415.69 281.05C391.92 269.15 296.83 269.15 296.83 269.15L273.07 269.15C273.07 269.15 177.97 269.15 154.21 281.05C94.77 304.85 94.77 352.44 94.77 352.44L94.77 507.13L475.12 507.13Z"
            />
          </g>
        </g>
        <path
          fillRule="evenodd"
          fill="none"
          stroke="#1d1d1b"
          strokeWidth="38.687"
          d="M225.34 266.24L225.34 266.24C168.19 266.24 121.42 219.43 121.42 162.22L121.42 129.37C121.42 72.15 168.19 25.36 225.34 25.36C282.49 25.36 329.26 72.15 329.26 129.37L329.26 162.22C329.26 219.43 282.49 266.24 225.34 266.24Z"
        />
        <path
          fillRule="evenodd"
          fill="none"
          stroke="#1d1d1b"
          strokeLinejoin="round"
          strokeWidth="38.687"
          d="M400.34 485.23L400.34 342.89C400.34 342.89 400.34 299.08 345.65 277.18C323.78 266.24 236.27 266.24 236.27 266.24L214.4 266.24C214.4 266.24 126.89 266.24 105.03 277.18C50.33 299.08 50.33 342.89 50.33 342.89L50.33 485.23L400.34 485.23Z"
        />
      </g>
    </>
  ),
  checkBreadcrumb: (
    <path
      className="st0"
      d="M496.8,58.9L496.8,58.9c-20.7-22.7-57.6-22.7-78.3,0L194.9,305.1L76.3,174.7L0.8,257.8l194,213.6l301.9-332.2c9.9-10.8,15.3-25.1,15.3-40.1C512,84,506.6,69.8,496.8,58.9z"
    />
  ),

  chevronLeft: (
    <path d="M412,48.2c0,12.9-4.9,25-13.7,34.1L230.5,255l78.8,81.1L414,443.8L347.7,512L98,255l37.3-38.4c0,0,65.6-67.5,196.7-202.5C340.9,5,352.6,0,365.2,0c12.5,0,24.3,5,33.1,14.1C407.2,23.2,412,35.4,412,48.2z" />
  ),

  chevronRight: (
    <path d="M100,48.2c0,12.9,4.9,25,13.7,34.1L281.5,255l-78.8,81.1L98,443.8l66.3,68.2L414,255l-37.3-38.4c0,0-65.6-67.5-196.7-202.5C171.1,5,159.4,0,146.8,0c-12.5,0-24.3,5-33.1,14.1C104.8,23.2,100,35.4,100,48.2z" />
  ),

  chevronUp: (
    <path d="M463.8,412c-12.9,0-25-4.9-34.1-13.7L257,230.5l-81.1,78.8L68.2,414L0,347.7L257,98l38.4,37.3c0,0,67.5,65.6,202.5,196.7c9.1,8.9,14.1,20.6,14.1,33.2c0,12.5-5,24.3-14.1,33.1C488.8,407.2,476.6,412,463.8,412z" />
  ),

  chevronDown: (
    <path d="M463.8,100c-12.9,0-25,4.9-34.1,13.7L257,281.5l-81.1-78.8L68.2,98L0,164.3L257,414l38.4-37.3c0,0,67.5-65.6,202.5-196.7c9.1-8.9,14.1-20.6,14.1-33.2c0-12.5-5-24.3-14.1-33.1C488.8,104.8,476.6,100,463.8,100z" />
  ),

  triangleLeft: (
    <path d="M456.2,466.2V45.8c0-17.1-9.5-32.7-24.6-40.6c-15.1-7.9-33.4-6.8-47.4,2.9L73.4,223.7 c-11.1,7.7-17.7,20.3-17.6,33.8c0.1,13.5,6.7,26.1,17.8,33.7L384.5,504c14.1,9.6,32.2,10.7,47.3,2.7 C446.8,498.8,456.2,483.2,456.2,466.2z" />
  ),

  triangleRight: (
    <path d="M55.8,466.2V45.8c0-17.1,9.5-32.7,24.6-40.6c15.1-7.9,33.4-6.8,47.4,2.9l310.9,215.6 c11.1,7.7,17.7,20.3,17.6,33.8c-0.1,13.5-6.7,26.1-17.8,33.7L127.5,504c-14.1,9.6-32.2,10.7-47.3,2.7 C65.2,498.8,55.8,483.2,55.8,466.2z" />
  ),

  triangleUp: (
    <path d="M466.2,456.2H45.8c-17.1,0-32.7-9.5-40.6-24.6c-7.9-15.1-6.8-33.4,2.9-47.4L223.7,73.4 c7.7-11.1,20.3-17.7,33.8-17.6c13.5,0.1,26.1,6.7,33.7,17.8L504,384.5c9.6,14.1,10.7,32.2,2.7,47.3 C498.8,446.8,483.2,456.2,466.2,456.2z" />
  ),

  triangleDown: (
    <path d="M466.2,55.8H45.8c-17.1,0-32.7,9.5-40.6,24.6c-7.9,15.1-6.8,33.4,2.9,47.4l215.6,310.9 c7.7,11.1,20.3,17.7,33.8,17.6c13.5-0.1,26.1-6.7,33.7-17.8L504,127.5c9.6-14.1,10.7-32.2,2.7-47.3 C498.8,65.2,483.2,55.8,466.2,55.8z" />
  ),

  arrowLeft: (
    <path d="M221.8,407L94.9,276.6h392.5c13.6,0,24.6-11.4,24.6-25.4c0-14-11-25.4-24.6-25.4H94.9l109.8-113.3 c9.6-9.9,9.6-26,0-35.9c-9.6-9.9-25.2-9.9-34.8,0L0,251.2l0,0l187,191.8L221.8,407z" />
  ),

  arrowRight: (
    <path d="M290.2,407l126.9-130.4H24.6C11,276.6,0,265.2,0,251.2c0-14,11-25.4,24.6-25.4h392.5L307.3,112.5 c-9.6-9.9-9.6-26,0-35.9c9.6-9.9,25.2-9.9,34.8,0L512,251.2l0,0L325,442.9L290.2,407z" />
  ),

  arrowUp: (
    <path d="M105,221.8L235.4,94.9v392.5c0,13.6,11.4,24.6,25.4,24.6c14,0,25.4-11,25.4-24.6V94.9l113.3,109.8 c9.9,9.6,26,9.6,35.9,0c9.9-9.6,9.9-25.2,0-34.8L260.8,0l0,0L69.1,187L105,221.8z" />
  ),

  arrowDown: (
    <path d="M105,290.2l130.4,126.9V24.6C235.4,11,246.8,0,260.8,0c14,0,25.4,11,25.4,24.6v392.5l113.3-109.8 c9.9-9.6,26-9.6,35.9,0c9.9,9.6,9.9,25.2,0,34.8L260.8,512l0,0L69.1,325L105,290.2z" />
  ),

  return: (
    <path
      id="XMLID_3_"
      d="M112.6,79.2L112.6,79.2c-5.2,0-10.1,2.2-13.6,6.1l-78.8,88.4c-4.9,5.5-16.3,18.7-16.8,19.3L0,196.9l3.5,3.8 c0.1,0.1,12.1,13.3,16.7,18.5l87.7,97.3l3.9,4.3l4.3-3.9l18.4-16.4l4.4-3.9l-3.9-4.4L65,214.6h319.8c50.1,0,90.9,40.8,90.9,90.9 s-40.8,90.9-90.9,90.9H326c-10,0-18.2,8.2-18.2,18.2c0,10,8.2,18.2,18.2,18.2h58.8c70.2,0,127.2-57.1,127.2-127.2 c0-70.2-57.1-127.2-127.2-127.2H64.8l61.3-68.7c6.7-7.5,6-19-1.5-25.7C121.4,80.9,117.1,79.2,112.6,79.2L112.6,79.2z"
    />
  ),

  play: (
    <path d="M412.7,247.9L165.6,0l-50.1,50.3L277.7,213l34.8,34.9L170.2,390.6v-244c0-19.6-15.9-35.6-35.5-35.6c-19.6,0-35.5,15.9-35.5,35.6v329.9c0,19.6,15.9,35.6,35.5,35.6c9.8,0,18.7-4,25.1-10.4L412.7,247.9z" />
  ),

  close: (
    <path d="M329.4,256L512,73.4L438.5,0L256,182.6L96.2,22.7C75.9,2.5,43,2.5,22.7,22.7C2.5,43,2.5,75.9,22.7,96.2L182.6,256L0,438.6L73.4,512L256,329.4l159.8,159.8c10.1,10.1,23.4,15.2,36.7,15.2c13.3,0,26.6-5.1,36.7-15.2c20.3-20.3,20.3-53.2,0-73.4L329.4,256z" />
  ),

  validRounded: (
    <g>
      <path d="M455.4,259c0,111.3-91.1,202.4-202.4,202.4c-111.3,0-202.4-91.1-202.4-202.4S141.7,56.6,253,56.6c20.2,0,37.9,2.5,55.7,7.6l40.5-40.5C318.8,13.6,285.9,6,253,6C113.8,6,0,119.9,0,259s113.8,253,253,253c139.1,0,253-113.8,253-253H455.4z" />
      <path d="M502.1,78.4c-5.3-5.5-12.4-8.5-20-8.5c-7.5,0-14.6,3-20,8.5L259.7,286.6L159.4,183.4l-39.9,41l140.2,144.2l242.4-249.2c5.3-5.5,8.3-12.8,8.3-20.5C510.4,91.2,507.4,83.9,502.1,78.4" />
    </g>
  ),

  checkmark: (
    <g>
      <circle cx="256.5" cy="255.5" r="255.5" />
      <path
        fill="#FFFFFF"
        d="M375.1,175.8c-4.1-4.1-8.2-6.1-12.3-6.1c-4.1,0-10.2,2-12.3,6.1L221.8,306.6l-63.4-65.4
                l-24.5,26.6l87.9,92l14.3-14.3l0,0l139-143.1c4.1-4.1,6.1-8.2,6.1-12.3C379.1,184,377.1,179.9,375.1,175.8"
      />
    </g>
  ),

  warningMark: (
    <g>
      <circle cx="254.7" cy="254.7" r="254.7" fill="#f12535" />
      <g style={{ isolation: 'isolate' }}>
        <path
          d="M225.66,274,213.12,134.45h87.81L288.38,274ZM257,357.1c-23.51,0-39.19-15.69-39.19-36.07S233.5,285,257,285s39.2,15.69,39.2,36.07S280.53,357.1,257,357.1Z"
          transform="translate(-2.3 -1.3)"
          fill="#fff"
        />
      </g>
    </g>
  ),

  warningRounded: (
    <g>
      <path d="M250,45.5c113,0,204.5,91.6,204.5,204.5S363,454.5,250,454.5S45.5,363,45.5,250 S137,45.5,250,45.5 M250,0C112.1,0,0,112.1,0,250s112.1,250,250,250s250-112.1,250-250S387.9,0,250,0L250,0z" />
      <circle cx="250" cy="356.9" r="36.5" />
      <path d="M250,298.3c17.3,0,31.2-14.1,31.2-31.6V110.8h-62.5v155.9C218.8,284.2,232.7,298.3,250,298.3z" />
    </g>
  ),

  check: (
    <path d="M481.3,63.8c-24.9-24.9-65.3-24.9-90.2,0L175.2,279.7L85,189.5l-85,85l180.4,180.4l85-85 L481.3,154C506.2,129.1,506.2,88.7,481.3,63.8z" />
  ),

  plus: (
    <path d="M419.8,167.1c51.7,0,89.5,34.5,89.5,83c0,48.5-37.7,84.1-89.5,84.1h-88.4v95.9 c0,44.2-34.5,81.9-80.8,81.9s-80.8-37.7-80.8-81.9v-95.9H2.7V167.1h167.1V0h161.7v167.1H419.8z" />
  ),

  minus: (
    <path d="M399,358.1H0V153.9h399c68.1,0,113,42.2,113,102.1C512,314.6,467.1,358.1,399,358.1z" />
  ),

  cross: (
    <path d="M38.4,485.4c-23-23-23.2-59.2,4.3-86.7l130.8-130.8L1,95.3L86.3,9.9l172.5,172.5L429.5,11.8 L511,93.3L340.3,264l130.4,130.4c27.8,27.8,29.9,65.9,5.3,90.6c-24.6,24.6-62.8,22.5-90.6-5.3L255,349.3L124.2,480.1 C96.7,507.6,61.4,508.4,38.4,485.4z" />
  ),

  trash: (
    <g>
      <polygon points="312.7,163.8 304.1,409 343.6,410.5 352.2,165.3" />
      <rect x="236.2" y="164.6" width="39.5" height="245.2" />
      <polygon points="159.8,165.3 168.4,410.5 207.9,409 199.3,163.8" />
      <path d="M368.6,62.3v-27C368.6,15.8,353.1,0,334,0H198.4c-19.1,0-34.6,15.8-34.6,35.3v27H20.9v41.4H62L94.7,493c0.9,10.7,9.4,18.9,19.7,18.9H397c10.2,0,18.8-8.2,19.7-18.9l32.7-389.3h41.8V62.3H368.6z M205.3,42.4h121.8v19.9H205.3V42.4zM378.8,470.6H132.5l-30.8-366.8h307.9L378.8,470.6z" />
    </g>
  ),

  phone: (
    <path d="M452.6,389.2l-43.9-65.1c-9.1-14-21.6-22.9-36.4-25.8c-14.6-2.8-29.7,0.6-43.6,10l-32.2,21.6 l-2.1-1.7c-3-2.3-5.8-4.4-8-6.5c-14.2-13.3-27.1-28.3-39.4-45.6l-13.7-20c-0.7-1-1.6-1.9-2-2.2c-0.8-0.9-1.6-1.7-3-2.8l-3.2-2.1 c-1-0.5-2-1-2.9-1.3c-0.8-0.3-1.5-0.5-2.6-0.8l-1.8-0.4c-1-0.2-2-0.3-3.9-0.3l-2.1,0.1c-3.6,0.4-7,1.6-9.9,3.6l-1.8,1.2 c-0.5,0.4-2.1,1.4-2.9,2.9c-0.9,1-1.6,2.1-2,3c-0.4,0.7-0.8,1.3-1.2,2.3l-0.4,1.1c-0.4,0.9-0.6,1.9-0.8,2.7l-0.3,1.3l-0.2,1.1 c-0.2,1.4-0.2,2.9-0.1,5.1l0.9,4.7c0.3,1.1,0.8,2.2,1.6,3.8c0.6,1.1,1.3,2.1,1.6,2.4l17.2,25.1l5.3,6.7 c11.7,15.2,23.8,28.6,36.8,40.8c3.9,3.7,7.8,6.7,11.8,9.8c3,2.3,5.7,4.4,8.7,7.1l1,0.9c11.1,8.5,24.2,8.8,36.1,0.8l40.6-27.3 c7.6-5.1,12.6-4.4,17.4,3.4l44.3,65.3c5.6,8.2,4.6,13.2-3.9,19.1c-3.7,2.7-7.4,5.1-11.6,7.8l-2.5,1.6c-7.6,4.9-15.8,10.2-23.5,16.4 c-10.1,7.3-20.8,9.5-33.7,7c-1.3-0.3-2.7-0.5-4-0.9c-27.8-7.3-52.1-23.5-70.1-36.8c-50.1-37.4-91.3-84.7-122.3-140.4 c-25.5-46.3-40.6-87.7-47.6-130c-4.2-25-4-43.7,0.7-60.4c2.7-9.3,7.9-16.5,15.9-21.9l40.3-27.1c7.6-4.8,12.8-4.2,18.2,3.7 c4.7,6.4,9.1,13,14.3,20.9l29.6,43.9c2.9,4.3,4.1,7.8,3.6,10.4c-0.5,2.6-2.9,5.4-7.2,8.3l-3.4,2.3c-2.2,1.5-4.5,3-6.9,4.6 c-10.5,7.2-19.5,13.2-29.3,19.1l-1.2,0.7l-1,0.8c-14.2,10.4-12.6,24.3-12.1,29l0.2,1.5c2.2,10.8,5.6,21.8,10.4,33.7l3.3,8.3l14-5.9 c3.1-1.3,6.3-2.6,9.4-4l3.5-1.6c2.1-1,4.1-1.9,6.2-2.7l8.3-3.1l-3.3-8.2c-2.2-5.6-4-10.8-5.4-15.7c6.7-4.3,13.2-8.7,19.7-13.1 l12.6-8.6c28.9-19.4,35.2-51.9,15.7-80.7l-21.9-32.4c-2.4-3.6-5-7.3-7.3-11.1c-4.8-7.3-9.9-15-15.2-22.2 c-9.2-13.3-21.6-21.9-36.1-24.7c-14.4-2.8-29.5,0.5-43.5,9.5L87.7,38.4c-17,11.4-28.4,27.1-34.1,46.8c-8.5,30.1-5.1,60-1.8,79.8 c7.9,47.6,24.6,93.4,52.6,144.1c34.2,61.5,79.5,113.5,134.9,154.8c21.6,15.8,50.8,35.1,85.7,44.3c2.2,0.5,4.5,1.1,6.6,1.5 c25.5,5,48.8-0.1,69.3-15.1l1-0.9c5.5-4.4,11.6-8.4,18.1-12.6l1.6-1c5.2-3.3,10.5-6.8,15.8-10.5c13.7-9.6,22.4-22.3,25.3-36.8 C465.6,418,462.1,403,452.6,389.2" />
  ),

  chat: (
    <g>
      <path d="M437.2,75c-48.4-48.4-112.7-75-181-75c-68.3,0-132.6,26.6-181,75 c-92.2,92.2-100.7,236.7-20.7,338.5c-9.5,17.8-20.2,29.8-32,35.5c-12.6,6.2-19.7,19.8-17.7,33.8c2.2,14,13,24.9,27,27.1 c6.4,1,12.7,1.4,18.8,1.4c30.4,0,61.9-9.6,89.2-27.2c35.8,18.2,75.9,27.9,116.3,27.9c68.4,0,132.6-26.6,181-74.9 c48.3-48.3,74.9-112.6,74.9-181C512.1,187.7,485.5,123.4,437.2,75 M103.2,419.4c3.6-8.2,2.1-17.9-3.9-24.7 c-73.2-82.7-69.4-208.8,8.8-287c39.6-39.6,92.2-61.3,148.1-61.3c56,0,108.6,21.8,148.1,61.3c39.5,39.6,61.3,92.3,61.3,148.3 c0,56.1-21.8,108.7-61.3,148.2h0c-39.6,39.6-92.2,61.3-148.1,61.3c-37.4,0-74.1-9.9-106.2-28.8c-3.6-2.1-7.7-3.2-11.6-3.2 c-5,0-10.1,1.7-14.2,4.8c-15.9,12.3-31.7,19-45.2,22.6C88,449.6,96,435.8,103.2,419.4" />
      <path d="M162.9,205.5h192.5c11.9,0,21.6-10.6,21.6-23.6s-9.7-23.6-21.6-23.6H162.9 c-11.9,0-21.6,10.6-21.6,23.6S151,205.5,162.9,205.5" />
      <path d="M162.9,276.3h192.5c11.9,0,21.6-10.6,21.6-23.6s-9.7-23.6-21.6-23.6H162.9 c-11.9,0-21.6,10.6-21.6,23.6S151,276.3,162.9,276.3" />
      <path d="M162.9,347h192.5c11.9,0,21.6-10.6,21.6-23.6c0-13-9.7-23.6-21.6-23.6H162.9 c-11.9,0-21.6,10.6-21.6,23.6C141.3,336.4,151,347,162.9,347" />
    </g>
  ),

  avatar: (
    <path d="M510.7,423.8l-0.1-0.2l-0.1-0.2c-22.1-82-83.1-148.1-162.1-177.6c29.6-25.7,48.3-63.5,48.3-105.6C396.8,62.7,333.7,0,256,0c-77.8,0-140.8,62.7-140.8,140.1c0,42.2,18.7,79.9,48.3,105.6c-79,29.5-140,95.6-162.1,177.6c-0.9,3.4-1.4,6.8-1.4,10.2c0,10.5,4.3,20.2,11.3,27.4c7,7.1,16.9,11.7,28,11.7h2.5h178.6v-53.2H58.7c29.6-80,106.8-137.2,197.3-137.2c90.5,0,167.8,57.2,197.3,137.2H312.9c-14.8,0-26.7,11.9-26.7,26.6c0,14.7,11.9,26.6,26.7,26.6h157.2h2.4c22.2,0,39.5-17.9,39.5-38.9C512,430.5,511.6,427.1,510.7,423.8 M256,53.2c24.1,0,45.9,9.7,61.8,25.5c15.8,15.8,25.6,37.5,25.6,61.5c0,24-9.8,45.7-25.6,61.5c-15.8,15.8-37.7,25.5-61.8,25.5c-24.1,0-45.9-9.7-61.8-25.5c-15.8-15.8-25.6-37.5-25.6-61.5c0-24,9.8-45.7,25.6-61.5C210,62.9,231.9,53.2,256,53.2" />
  ),

  download: (
    <g>
      <path d="M417.4,135.5c-6-30.8-21.9-58.3-46.3-79.6c-27.7-24.3-63.6-37.6-101.2-37.6 c-29,0-57.2,7.9-81.4,22.9c-19.3,11.9-35.6,28-47.2,46.7c-4.4-0.7-8.9-1-13.3-1c-46.3,0-83.9,36-83.9,80.3c0,4.6,0.4,9.3,1.3,14.2 C16.9,202.2,0,234.8,0,268.9c0,28.4,11.1,56,31.2,77.9c20.8,22.4,48.3,35.7,77.6,37.2h89.9c9.9,0,18-7.7,18-17.3 c0-9.5-8.1-17.3-18-17.3l-88.5,0c-40.2-2.4-74.2-39.3-74.2-80.6c0-26.7,15-51.6,39.1-65.1c7.5-4.2,10.8-13,7.9-21 c-1.9-5-2.9-10.1-2.9-15.7c0-25.3,21.5-45.8,47.9-45.8c5.7,0,11.2,0.9,16.3,2.7c8.8,3.1,18.5-0.7,22.5-8.8 c18.7-38,59.2-62.5,103.1-62.5c59,0,107.8,42.3,113.4,98.5c0.8,7.8,6.9,14.1,14.9,15.3c44.2,7.2,77.6,46.4,77.6,91 c0,47.2-38.9,88.4-86.4,91.9h-29.3c0,0,0,0,0,0c-0.8-0.1-1.5-0.1-2.3,0h-53.6v34.5h8.9h44.6H390l1.3,0 c32.7-2.3,63.2-16.7,85.8-40.5c22.5-23.6,34.8-54.2,34.8-85.9C511.9,201.4,472.3,150.6,417.4,135.5" />
      <path d="M338.9,308.2C339,308.2,339,308.2,338.9,308.2c5.3,0,10.3-1.8,14-5.2c7.7-6.8,7.7-18,0-24.8 L272,206.1c-7.5-6.7-20.8-6.5-27.8,0l-80.9,72.1c-7.7,6.8-7.7,18,0,24.8c7.5,6.7,20.8,6.5,27.8,0l47.4-42.2v215.3 c0,9.7,8.8,17.5,19.7,17.5c10.9,0,19.7-7.9,19.7-17.5V260.8l47.3,42.2C328.8,306.3,333.7,308.2,338.9,308.2" />
    </g>
  ),

  pencil: (
    <path
      d="M143,432.6l-68.3-68.1l238.1-237.6l73.1,72.9L189.4,395.5c10.2,10.8,21,21.1,31.8,31.4
            l284.4-283.8c8.7-8.6,8.7-22.7,0-31.9L401.6,6.5c-8.7-8.6-22.7-8.6-31.9,0l-72.5,72.9L7,368.3c-3.8,4.3-6.5,9.7-6.5,15.7L0,489.3
            c0,5.9,2.2,11.9,6.5,16.2c4.3,4.3,9.8,6.5,15.7,6.5l105-0.5c5.9,0,11.4-2.2,15.7-6.5l36.9-36.8L143,432.6z M118.1,466.1l-73.2,0.5
            l0.5-72.9l0.1-0.1L118.1,466.1z M417.8,168l-73.1-72.9l41.1-41l73.1,72.9L417.8,168z"
    />
  ),

  handLuggage: (
    <path
      d="M443.3,142.4h-33.6C395.9,68.8,330.5,12.8,251.9,12.8s-144,56-157.8,129.6H68.7
            C30.8,142.4,0,172.7,0,210.1v221.4c0,37.3,30.8,67.7,68.7,67.7h261.7v-17.3v-21.8h-39.3v0.4H68.7c-16.2,0-29.4-13-29.4-29V210.1
            c0-16,13.2-29,29.4-29h23.7V332h39.3V181.1h311.6c16.2,0,29.4,13,29.4,29v221.4c0,13.9-10,25.6-23.3,28.4v0.7h-12.9
            c-10.8,0-19.6,8.7-19.6,19.3c0,10.3,9.1,19.3,19.6,19.3h17v-0.9c33-4.9,58.5-32.9,58.5-66.8V210.1
            C512,172.7,481.2,142.4,443.3,142.4z M134.2,142.4c13.1-52.1,60.8-90.9,117.7-90.9c56.9,0,104.6,38.8,117.7,90.9H134.2z"
    />
  ),

  breadSlices: (
    <g>
      <path
        d="M510.7,166.8c-6.5-42.4-43.3-74.7-88.3-78.1C420,39.4,377.8,0,326.2,0H97.5
                C49.5,0,8.1,33.7,1.3,78.5c-5.6,36.8,12,74.2,44,93.8v202.5c0,27,21.9,48.9,48.8,48.9h39.4v0.1h38.8v-0.1h157.2
                c26.9,0,48.9-21.9,48.9-48.9V172.2c17.1-10.6,30.3-26.4,37.7-45c27.9,0.7,52.4,20.4,56.3,45.5c3.7,24.3-9.8,48.3-32.8,58.4
                c-7.1,3.1-11.6,10.1-11.6,17.8v214.2c0,5.5-4.5,10-10,10H182.4c-5.4,0-9.7-4.3-9.9-9.6v-3.6c0-10.7-8.7-19.4-19.4-19.4
                c-10.4,0-19.4,9.1-19.4,19.4v3.1h-0.1v0.1c0,27,21.9,48.9,48.8,48.9h235.5c26.9,0,48.8-21.9,48.8-48.9V260.6
                C498.7,241,516.4,203.6,510.7,166.8 M351.2,142.7c-7.1,3.1-11.6,10.1-11.6,17.8v214.2c0,5.5-4.5,10-10,10H94.1c-5.5,0-10-4.5-10-10
                V160.5c0-7.7-4.6-14.7-11.6-17.8c-23.1-10.1-36.5-34.1-32.8-58.4C43.6,58.8,69,38.9,97.5,38.9h228.7c28.4,0,52.9,19.6,56.9,45.5
                C386.8,108.9,373.7,132.9,351.2,142.7"
      />
      <path
        d="M241.2,103.3l-80.8,80.9c-3.4,3.4-5.2,7.8-5.2,12.6c0,4.8,1.8,9.2,5.2,12.6
                c3.5,3.5,8,5.2,12.5,5.2c4.6,0,9.1-1.7,12.6-5.2l80.8-80.9c6.9-6.9,6.9-18.2,0-25.1C259.6,96.6,247.9,96.6,241.2,103.3"
      />
      <path
        d="M160.5,287.5c-3.4,3.4-5.2,7.8-5.2,12.6c0,4.8,1.8,9.2,5.2,12.6c3.3,3.4,7.8,5.2,12.5,5.2
                c4.7,0,9.2-1.9,12.6-5.2l80.8-80.9c6.9-6.9,6.9-18.2,0-25.1c-6.7-6.7-18.4-6.7-25.1,0L160.5,287.5z"
      />
    </g>
  ),

  ticket: (
    <g>
      <path
        d="M50.98,375.26c0.09,0.09,0.2,0.14,0.28,0.23c0.1,0.09,0.17,0.22,0.27,0.31c0.44,0.41,0.94,0.7,1.41,1.06
		c0.55,0.43,1.07,0.89,1.65,1.25c0.58,0.37,1.18,0.64,1.77,0.93c0.63,0.32,1.24,0.66,1.9,0.91c0.61,0.23,1.23,0.38,1.85,0.54
		c0.68,0.19,1.34,0.41,2.04,0.52c0.62,0.11,1.23,0.13,1.86,0.18c0.57,0.05,1.14,0.17,1.71,0.17c0.14,0,0.28-0.04,0.42-0.04
		c0.61-0.01,1.21-0.11,1.82-0.18c0.72-0.07,1.44-0.14,2.16-0.3c0.6-0.12,1.17-0.34,1.76-0.52c0.7-0.22,1.39-0.41,2.06-0.7
		c0.6-0.25,1.15-0.6,1.72-0.91c0.63-0.34,1.25-0.65,1.84-1.05c0.58-0.41,1.12-0.9,1.67-1.36c0.43-0.37,0.9-0.66,1.3-1.06
		c0.1-0.1,0.15-0.2,0.24-0.3c0.09-0.1,0.22-0.16,0.31-0.27c5.7-6.14,13.92-9.67,22.55-9.67c17.25,0,31.29,14.03,31.29,31.28
		c0,8.62-3.54,16.84-9.7,22.55c-0.1,0.1-0.17,0.21-0.26,0.31c-0.1,0.09-0.21,0.15-0.3,0.25c-0.41,0.41-0.7,0.88-1.06,1.3
		c-0.47,0.55-0.96,1.08-1.37,1.67c-0.38,0.56-0.68,1.16-1.01,1.75c-0.34,0.6-0.7,1.2-0.96,1.83c-0.27,0.63-0.44,1.26-0.65,1.91
		c-0.2,0.65-0.43,1.27-0.57,1.93c-0.14,0.66-0.19,1.3-0.26,1.97c-0.07,0.67-0.17,1.33-0.18,2c-0.01,0.65,0.06,1.29,0.11,1.94
		c0.05,0.69,0.07,1.36,0.2,2.04c0.12,0.64,0.31,1.25,0.48,1.88c0.19,0.67,0.35,1.34,0.6,2c0.24,0.62,0.57,1.19,0.86,1.78
		c0.31,0.63,0.61,1.26,0.98,1.87c0.36,0.57,0.8,1.08,1.22,1.61c0.37,0.47,0.67,0.98,1.08,1.43c0.09,0.11,0.21,0.17,0.3,0.27
		c0.1,0.1,0.15,0.21,0.24,0.31l45.57,45.57c4.07,4.07,9.41,6.11,14.75,6.11c5.34,0,10.67-2.04,14.75-6.12l294.09-294.08
		c3.91-3.91,6.11-9.22,6.11-14.75c0-5.53-2.2-10.84-6.11-14.75l-45.57-45.57c-0.1-0.09-0.2-0.14-0.28-0.23
		c-0.11-0.09-0.17-0.22-0.27-0.31c-0.45-0.42-0.95-0.71-1.42-1.07c-0.54-0.43-1.06-0.88-1.64-1.24c-0.59-0.38-1.21-0.66-1.83-0.96
		c-0.61-0.31-1.2-0.64-1.83-0.88c-0.64-0.24-1.29-0.4-1.95-0.58c-0.65-0.18-1.27-0.38-1.92-0.49c-0.66-0.12-1.31-0.14-1.99-0.19
		c-0.68-0.05-1.33-0.13-2.01-0.12c-0.65,0.01-1.28,0.12-1.93,0.19c-0.69,0.08-1.36,0.13-2.04,0.27c-0.64,0.13-1.24,0.35-1.86,0.55
		c-0.67,0.21-1.32,0.39-1.97,0.67c-0.62,0.26-1.2,0.62-1.79,0.95c-0.6,0.33-1.21,0.62-1.77,1.02c-0.6,0.41-1.14,0.91-1.7,1.39
		c-0.42,0.35-0.89,0.65-1.28,1.04c-0.09,0.1-0.15,0.2-0.24,0.3c-0.09,0.1-0.22,0.17-0.31,0.27c-5.72,6.14-13.94,9.68-22.56,9.68
		c-17.25,0-31.29-14.04-31.29-31.28c0-8.63,3.53-16.84,9.7-22.56c0.11-0.1,0.17-0.21,0.26-0.31c0.09-0.09,0.21-0.15,0.3-0.25
		c0.41-0.41,0.7-0.88,1.06-1.3c0.47-0.55,0.96-1.08,1.36-1.67c0.39-0.56,0.68-1.16,1.01-1.75c0.33-0.6,0.7-1.2,0.96-1.83
		c0.27-0.63,0.44-1.26,0.65-1.91c0.2-0.65,0.43-1.27,0.58-1.93c0.13-0.66,0.19-1.3,0.26-1.97c0.07-0.67,0.18-1.33,0.19-2
		c0.01-0.65-0.06-1.29-0.12-1.94c-0.05-0.69-0.07-1.36-0.2-2.04c-0.11-0.64-0.31-1.25-0.48-1.88c-0.19-0.67-0.34-1.34-0.59-2
		c-0.24-0.62-0.57-1.19-0.86-1.78c-0.32-0.63-0.61-1.26-0.98-1.87c-0.36-0.57-0.8-1.08-1.22-1.61c-0.36-0.47-0.67-0.98-1.08-1.43
		c-0.09-0.1-0.22-0.18-0.31-0.28c-0.08-0.1-0.15-0.2-0.24-0.3L328.98,6.11c-8.14-8.15-21.35-8.15-29.49,0L5.4,300.19
		c-3.9,3.92-6.1,9.23-6.1,14.76c0,5.53,2.2,10.84,6.11,14.75L50.98,375.26z M314.24,50.36l17.89,17.89
		c-6.17,10.85-9.54,23.28-9.54,36.04c0,40.25,32.76,73,73,73c12.77,0,25.2-3.38,36.05-9.54l17.88,17.88L184.93,450.21l-17.88-17.89
		c6.16-10.84,9.54-23.28,9.54-36.04c0-40.26-32.76-73-73-73c-12.77,0-25.2,3.38-36.05,9.54l-17.88-17.88L314.24,50.36z"
      />
      <path
        d="M192.1,289.8c5.52,0,11.03-2.11,15.24-6.32l75.45-75.44c8.42-8.41,8.42-22.06,0-30.48
		c-8.42-8.42-22.07-8.42-30.48,0l-75.45,75.44c-8.42,8.41-8.42,22.06,0,30.48C181.08,287.7,186.58,289.8,192.1,289.8z"
      />
      <path
        d="M263.73,270.07l-33.87,33.87c-8.82,8.82-8.82,23.11,0,31.93c4.42,4.42,10.18,6.62,15.97,6.62
		c5.78,0,11.55-2.21,15.97-6.62L295.66,302c8.82-8.82,8.82-23.11,0-31.93C286.84,261.25,272.55,261.25,263.73,270.07z"
      />
    </g>
  ),

  luggage: (
    <path
      d="M496.5,118.4h-132V31.2h-225v87.1h-124c-8.6,0-15.5,7.4-15.5,16.4v329.6
            c0,9.1,6.9,16.4,15.5,16.4h481c8.6,0,15.5-7.4,15.5-16.4V134.8C512,125.7,505.1,118.4,496.5,118.4z M170.5,64.1h163v54.3h-163V64.1z
            M481,447.9h-46V208.7c0-9.1-6.9-16.4-15.5-16.4c-8.6,0-15.5,7.4-15.5,16.4v239.2H31V151.2h45.4v232.9c0,9.1,6.9,16.4,15.5,16.4
            c8.6,0,15.5-7.4,15.5-16.4V151.2h32.2h225H481V447.9z"
    />
  ),

  shield: (
    <path d="M469.5,90.4c-0.2-10.3-7.7-18.8-17.7-20.2C421,66,391,58.6,362.6,48.2C332.2,37,299.7,21.8,266.1,2.9c-6.7-3.8-13.6-3.8-20.3,0c-33.5,19-65.8,34.2-96.2,45.3c-28.6,10.4-58.5,17.9-89,22.1c-9.5,1.3-17,9.3-18.2,20.2c-2.9,126,25.1,230.8,83.3,311.4c31.9,44.2,72.3,80.3,119.3,106.9c3,2.2,6.8,3.3,10.8,3.3c3.7,0,7.5-1,10.8-2.9c47.9-27.8,88.1-63.9,119.5-107.3C444.3,321.5,472.3,216.8,469.5,90.4 M428,108.6c0,109.5-25.4,200.1-75.4,269.3c-25.6,35.4-58.1,65.6-96.5,89.6c-38.8-24.3-71.3-54.4-96.5-89.6C109.4,308.1,84,217.6,84,108.6c26.6-4.7,53.2-12,81.1-22.2c28-10.3,58.5-24.3,90.9-41.7c32.7,17.6,63.2,31.6,90.6,41.7C374.1,96.5,401.4,104,428,108.6" />
  ),

  shieldCrossed: (
    <g>
      <path
        d="M469.5,90.4c-0.2-10.3-7.7-18.8-17.7-20.2C421,66,391,58.6,362.6,48.2
            	C332.2,37,299.7,21.8,266.1,2.9c-6.7-3.8-13.6-3.8-20.3,0c-33.5,19-65.8,34.2-96.2,45.3c-28.6,10.4-58.5,17.9-89,22.1
            	c-9.5,1.3-17,9.3-18.2,20.2c-2.9,126,25.1,230.8,83.3,311.4c31.9,44.2,72.3,80.3,119.3,106.9c3,2.2,6.8,3.3,10.8,3.3
            	c3.7,0,7.5-1,10.8-2.9c47.9-27.8,88.1-63.9,119.5-107.3C444.3,321.5,472.3,216.8,469.5,90.4 M428,108.6
            	c0,109.5-25.4,200.1-75.4,269.3c-25.6,35.4-58.1,65.6-96.5,89.6c-38.8-24.3-71.3-54.4-96.5-89.6C109.4,308.1,84,217.6,84,108.6
            	c26.6-4.7,53.2-12,81.1-22.2c28-10.3,58.5-24.3,90.9-41.7c32.7,17.6,63.2,31.6,90.6,41.7C374.1,96.5,401.4,104,428,108.6"
      />
      <path
        d="M189.3,311.6c-7.4-7.4-7.5-19.2,1.4-28.1l42.3-42.3l-55.8-55.8l27.6-27.6l55.8,55.8l55.2-55.2
            	l26.4,26.4L287,240l42.2,42.2c9,9,9.7,21.3,1.7,29.3c-8,8-20.3,7.3-29.3-1.7l-42.2-42.2L217.1,310
            	C208.2,318.8,196.8,319.1,189.3,311.6z"
      />
    </g>
  ),

  dog: (
    <g>
      <path
        d="M385.1,121.6c-8.5,0-15.4-6.9-15.4-15.4c0-8.5,6.9-15.4,15.4-15.4c8.5,0,15.4,6.9,15.4,15.4
                C400.4,114.7,393.6,121.6,385.1,121.6"
      />
      <path
        d="M318.5,472.9c-12.5,0-22.7-10.2-22.7-22.7v-51.2h-17c-10.6,0-14.3,5-19.6,15.5l-0.7,1.3l1.3,0.7
                c9.8,5.5,17.8,13.6,23.3,23.3c3.7,6.8,3.6,14.9-0.4,21.7c-4.2,7.1-11.8,11.4-19.9,11.4H32c-17.6,0-32-14.3-32-32s14.3-32,32-32
                l47.7,0.1l0-0.1h29.6c12.2,22.8,35.6,37,61.3,37h84.2l-3.6-2.8c-5.3-4-11.9-6.8-18.9-9.6c-2.4-1-4.4-1.8-6.4-2.7l-4.1-1.8l7.6-15
                c14.6-23,16.4-61.4-9.3-87.1l-3-3l19.1-19.1l3,3c16.9,16.9,26.8,39.6,28,64l0.1,1.9l1.8-0.5c3.4-0.9,6.7-1.3,9.9-1.3h17v-18.5h27
                v92.4h56.7l-3.6-2.8c-7.7-5.9-17.6-7-29-8.3l-9.8-1.2l8.3-66.3l1.7-1.1c21-12.9,35.9-26.6,40.2-51.7c5.1-29.4-5.2-51.3-34.2-73.3
                l-1.7-1.3v-16.2l0.1-1.1c0.2-7.5,6.4-14.2,13.5-14.2c3.6,0,7,1.5,9.5,4.2c2.6,2.7,4,6.4,4,10.2v3.7l0.6,0.5
                c27.5,22.1,40.8,57.3,34.9,92c-4.4,25.8-20,49.1-42.7,64l-0.6,0.4l-3.3,26.8l1.4,0.3c16.3,3.6,30.4,13.9,38.7,28.2
                c4.1,7,4.1,15.4,0,22.5c-4.1,7.2-11.6,11.6-19.9,11.6H318.5z M31.9,435.9c-2.7,0-4.9,2.3-4.9,5c0,2.8,2.2,5,5,5h71.5l-2.4-2.6
                c-1.7-1.8-3.3-3.9-5.4-6.6l-0.5-0.6L31.9,435.9z"
      />
      <path
        d="M88.4,382.5c-3.6,0-7-1.5-9.6-4.2c-2.6-2.7-4-6.4-4-10.2v-3.3c2.8-21.2,12.9-41.9,27.7-56.7
                c17.3-17.1,94.2-61.3,145.1-90.6l6.8-3.9l-3.9-0.9c-26-5.8-47.1-33.2-47.1-60.9v-14.5c0-14,5.4-27.1,15.3-37L262,57
                c11.5-11.5,26.7-17.8,42.6-17.8h64.9c15.9,0,30.9,6.2,42.2,17.5l23,23c13.9,13.9,28.1,15,45.2,15l9.3,0c12.5,0,22.7,10.2,22.8,22.7
                c0,6.8-7.5,20-19.6,39.3c-1.4,2.2-2.5,4-3.3,5.2c-11.2,18.6-37.9,33.8-59.6,33.8c-0.1,0-6.2,0.3-15.1,0.3h0
                c-8.8,0-17.1-0.3-24.6-0.9c-29.6-3.2-39-10.7-39.1-10.8c-9.2-7.4-15.5-17.7-17.8-29l-1-5.1h27.5l1,2.8c3.3,9.4,12.2,15.7,22,15.7
                h47.2c13.1,0,29.8-9.5,36.5-20.7l8.4-14l-1-0.8c-3.7-3-6.6-6.8-8.5-11.2l-0.4-0.8l-0.9-0.1c-18.2-1.7-35.2-9.6-47.9-22.3l-23-23
                c-6.1-6.1-14.5-9.6-23.1-9.6h-46.7v88.2c0,23.7-14.1,45.1-36,54.6l-0.9,0.4l0,17.3l-2.1,1.2c-13.6,7.9-133.6,77.1-154.4,92.6
                c-14.5,10.8-24.1,26.4-27.2,44.1l0,3.6c0,3.7-1.5,7.4-4.1,10.1C95.4,381,91.9,382.5,88.4,382.5L88.4,382.5z M293.7,68.2
                c-4.8,1.6-9.2,4.4-12.7,7.9l-43.3,43.3c-4.8,4.8-7.4,11.2-7.4,17.9v15c0,17,12.2,34.6,32.6,34.6c18.1,0,32.8-14.6,32.8-32.5V67.4
                L293.7,68.2z"
      />
    </g>
  ),

  lock: (
    <g>
      <path
        d="M326.4,192.5H157.1v-67c0-45.7,44.4-82.9,98.9-82.9c54.5,0,98.9,37.2,98.9,82.9v26.6l0.1,9.8
                c0,5.6-0.3,31,0,31.1c0.3,0.1,18.6,0,25.4,0c7,0,24.9,0.1,25.4,0.1c0.6,0,0-25.4,0-31.1v-10.2l0-26.2C405.9,56.3,338.7,0,256,0
                S106.2,56.3,106.2,125.5v67.4c-37.9,3.2-67.8,30.2-67.8,62.9v193c0,34.9,34,63.2,75.5,63.2h284.2c41.7,0,75.5-28.3,75.5-63.2v-193
                c0-32.4-29.2-59.2-66.7-62.8L326.4,192.5z M422.7,448.8c0,11.3-11,20.6-24.6,20.6H113.9c-13.6,0-24.6-9.2-24.6-20.6v-193
                c0-11.4,11-20.6,24.6-20.6h284.2c13.6,0,24.6,9.2,24.6,20.6V448.8z"
      />
      <path
        d="M256,325.8c-15.1,0-27.2,13.1-27.2,29.3v57.7c0,16.3,12.1,29.3,27.2,29.3
                c15.1,0,27.2-13.1,27.2-29.3v-57.7C283.2,339,271.1,325.8,256,325.8"
      />
    </g>
  ),

  lockOpen: (
    <g>
      <path
        d="M382.3,193l-67.4-0.5H173.1v-67c0-45.7,37.2-82.9,82.9-82.9c45.7,0,82.9,37.2,82.9,82.9v2.2h0
                v9.8c0,5.6,2.2,10.9,6.2,14.8c4,4,9.4,6.1,15.1,6.1c5.9,0,11.2-2.3,15.1-6.2c3.9-3.8,6.3-9,6.3-14.8v-10.2h0v-1.8
                C381.5,56.3,325.3,0,256,0c-69.3,0-125.5,56.3-125.5,125.5v67.4c-31.8,3.2-56.7,30.2-56.7,62.9v193c0,34.9,28.4,63.2,63.2,63.2h238
                c34.9,0,63.2-28.3,63.2-63.2v-193C438.2,223.4,413.8,196.6,382.3,193z M395.6,448.8c0,11.3-9.2,20.6-20.6,20.6H137
                c-11.4,0-20.6-9.2-20.6-20.6v-193c0-11.4,9.2-20.6,20.6-20.6h238c11.4,0,20.6,9.2,20.6,20.6V448.8z"
      />
      <path
        d="M256,350.4c-10.5,0-19,9.6-19,21.6v42.4c0,12,8.5,21.6,19,21.6c10.5,0,19-9.6,19-21.6V372
                C275,360.1,266.5,350.4,256,350.4"
      />
    </g>
  ),

  route: (
    <g>
      <path
        d="M107.6,87.6c-19.7,0-35.7,16-35.7,35.7c0,19.7,16,35.7,35.7,35.7c19.7,0,35.7-16,35.7-35.7
                C143.3,103.6,127.3,87.6,107.6,87.6"
      />
      <path
        d="M463.4,399.1c-19.5,0-37.1,11.7-44.7,29.5h-118c-7.6-17.8-25.2-29.5-44.7-29.5
                c-19.5,0-37.1,11.7-44.7,29.5h-29c-13.8,0-25.1-11.3-25.1-25.1s11.3-25.1,25.1-25.1h147.4c34.9,0,63.4-28.4,63.4-63.4
                c0-34.9-28.4-63.3-63.4-63.3h-29c-7.6-17.8-25.2-29.5-44.7-29.5c-19.5,0-37.1,11.7-44.7,29.5h-65.5l47.9-63.8
                c14.1-18.7,21.5-41,21.5-64.5c0-59.3-48.3-107.6-107.6-107.6C48.3,15.7,0,64,0,123.3c0,23.5,7.4,45.8,21.5,64.5l70.6,94.1
                c3.1,4.3,8.2,7.3,13.5,7.8c0.7,0.1,1.3,0.1,2,0.1h103.7c7.6,17.8,25.2,29.5,44.7,29.5c19.5,0,37.1-11.7,44.7-29.5h29
                c13.8,0,25.1,11.3,25.1,25.1c0,13.9-11.3,25.1-25.1,25.1H182.3c-34.9,0-63.3,28.4-63.3,63.3c0,34.9,28.4,63.4,63.3,63.4h29
                c7.6,17.8,25.2,29.5,44.7,29.5c19.5,0,37.1-11.7,44.7-29.5h118c7.6,17.8,25.2,29.5,44.7,29.5c26.8,0,48.6-21.8,48.6-48.6
                C512,420.9,490.2,399.1,463.4,399.1 M473.8,447.7c0,5.7-4.7,10.4-10.4,10.4c-5.7,0-10.4-4.7-10.4-10.4c0-5.7,4.6-10.4,10.4-10.4
                C469.1,437.3,473.8,442,473.8,447.7 M266.4,447.7c0,5.7-4.7,10.4-10.4,10.4c-5.7,0-10.4-4.7-10.4-10.4c0-5.7,4.6-10.4,10.4-10.4
                C261.7,437.3,266.4,442,266.4,447.7 M266.4,270.7c0,5.7-4.7,10.4-10.4,10.4c-5.7,0-10.4-4.7-10.4-10.4s4.6-10.4,10.4-10.4
                C261.7,260.4,266.4,265,266.4,270.7 M176.9,123.3c0,15.1-4.8,29.5-13.8,41.6l-55.5,74l-55.5-74c-9-12.1-13.8-26.4-13.8-41.6
                c0-38.2,31.1-69.3,69.3-69.3C145.8,54,176.9,85.1,176.9,123.3"
      />
    </g>
  ),

  babyBed: (
    <path
      d="M482.6,209.8c0-10.6-8.6-19.2-19.2-19.2H70.8c21.6-81.6,84.7-123,131.6-143.2v85.6
            c0,10.6,8.6,19.2,19.2,19.2c10.6,0,19.2-8.6,19.2-19.2V19.2c0-6.2-3-12-7.9-15.6C227.8,0,221.4-1,215.6,1
            c-8.2,2.7-166.8,58-186,200.1c-0.3,1.9-0.1,3.7,0.1,5.5c-0.2,1-0.3,2.1-0.3,3.2v229c0,0.8,0.1,1.6,0.2,2.4c-0.1,0.8-0.2,1.6-0.2,2.4
            v49.1c0,10.6,8.6,19.2,19.2,19.2s19.2-8.6,19.2-19.2v-34.7h376.4v34.7c0,10.6,8.6,19.2,19.2,19.2c10.6,0,19.2-8.6,19.2-19.2v-49.1
            c0-0.8-0.1-1.6-0.2-2.4c0.1-0.8,0.2-1.6,0.2-2.4V209.8z M128.7,419.6H67.8V229h60.9V419.6z M236.8,419.6h-69.7V229h69.7V419.6z
             M344.9,419.6h-69.7V229h69.7V419.6z M444.2,419.6h-60.9V229h60.9V419.6z"
    />
  ),

  star: (
    <path
      d="M489.7,180.2l-141-13.1c-8.9-0.8-16.6-6.3-20.2-14.6L278,32.6c-8.1-19.8-36.8-19.8-44.8,0l-50.1,119.9
        c-3.2,8.3-11.3,13.9-20.2,14.6l-141,13.1c-21,2-29.5,27.7-13.7,41.6l106.3,91.4c6.9,5.9,9.7,14.6,7.7,23.4L90.2,464.8
        c-4.8,20.2,17.4,36.8,36,26.1l117.6-67.7c7.7-4.4,17-4.4,24.6,0l117.6,67.7c18.6,10.7,40.8-5.5,36-26.1l-31.5-128.2
        c-2-8.7,0.8-17.4,7.7-23.4l106.3-91.4C519.6,207.9,510.7,182.2,489.7,180.2z"
    />
  ),

  magnifier: (
    <g>
      <path d="M504.2,466.4L378,339.6c-1.3-0.6-31.3-22.5-45.9-31.4c-29,31.4-71.1,51.3-118,51.3c-87.3,0-158.3-68.5-158.3-152.8c0-84.2,71-152.8,158.3-152.8c87.3,0,158.3,68.5,158.3,152.8c0,2.8-0.2,5.5-0.4,8.2c-0.2,2.4-0.4,4.8-0.7,7.2c-1.6,11.2-4.4,22.4-8.9,33.4c-5.7,14,1.6,29.7,16.3,35.2c14.7,5.4,31.3-1.5,37-15.5c5.5-13.5,9.3-27.1,11.6-40.9l0.1,0c0.9-5.1,1.4-10.3,1.9-15.6c0.1-1.6,0.2-3.3,0.3-4.9c0.3-4.5,0.3-9.1,0.3-13.6c0-1.5,0-2.9,0-4.4c-0.2-4.2-0.4-8.3-0.9-12.5c-0.1-0.8-0.3-1.6-0.3-2.4c-0.3-2.9-0.8-5.8-1.3-8.7c-0.5-3.3-1.1-6.6-1.8-9.9c-0.5-2.4-1.1-4.8-1.7-7.2c-1-3.8-2.1-7.6-3.3-11.4c-0.6-1.8-1.2-3.7-1.8-5.5c-1.6-4.4-3.3-8.7-5.2-13c-0.5-1.2-1-2.5-1.6-3.7c-2.5-5.2-5.2-10.4-8.1-15.4c-0.2-0.3-0.3-0.5-0.4-0.8c-3.2-5.4-6.6-10.7-10.3-15.8c-0.7-0.9-1.4-1.7-2.1-2.6c-2.9-3.8-5.9-7.6-9.1-11.3c-1.6-1.9-3.4-3.7-5.1-5.5c-2.4-2.5-4.8-5-7.3-7.4c-2.1-2-4.3-4-6.4-5.9c-2.4-2.1-4.9-4.2-7.4-6.2c-2.3-1.8-4.6-3.7-7-5.4c-2.9-2.1-5.9-4.1-8.9-6.1v0.3C304.3,14.8,261,0,214.1,0C96.1,0,0,92.7,0,206.7c0,114,96.1,206.7,214.1,206.7c44.3,0,86.5-12.9,122.7-37.4L464,503.7c5.3,5.3,12.5,8.3,20.1,8.3c7.3,0,14.1-2.7,19.4-7.5C514.5,494.2,514.9,477.1,504.2,466.4" />
    </g>
  ),

  person: (
    <g>
      <g>
        <g>
          <path
            d="M368.2,110.4c-2.9-56.2-32.5-82.9-56.7-95.5C293.3,5.4,272.3,0.4,248.1,0H247c-12.9,0-38.2,1.9-62.6,14.5
                        C159.8,27.1,129.8,54,127,110.1c-0.9,8.5-7.8,84.7,36.3,129.7c20.5,21,48.2,31.9,82.4,32.4h2.5h1.2c34.2-0.5,61.9-11.4,82.5-32.4
                        C376,194.8,369.1,118.7,368.2,110.4z M327.5,114.3l0.1,0.2c0.7,7.6,5.4,68.4-26.3,100.7C288.4,228.5,271,235,247,235.2
                        c-23-0.2-40.4-6.7-53.2-19.9C161,181.9,167.1,118,167.5,114l0,0l0.1-1.4c3.3-65.6,51-75.4,79.2-75.4h1.2
                        c34.5,0.7,76.2,14.3,79.3,75.1L327.5,114.3z M247.6,4.9L247.6,4.9L247.6,4.9L247.6,4.9z"
          />
        </g>
      </g>
      <path
        d="M461,373.6c-1.1-14.9-13.6-42-55-51.7c-34-7.9-69.7-32.6-70.1-32.8c-9.2-6.4-23-5.4-30.7,2.3c-7.7,7.7-6.5,19.2,2.7,25.6
                c1.7,1.2,43.2,29.9,86.3,39.9c21.2,4.9,23,16.9,23.1,18.9l0.5,3.9c0.1,0.3,7.9,30.5,1,60.9c-6,6.7-24.3,27.1-163.2,35
                c-140.7-7.7-157.1-27.5-162.5-34c-0.2-0.3-0.4-0.5-0.7-0.8c-7-30.5,0.8-60.8,0.9-61.1l0.5-3.5c0.1-2.4,2-14.4,23.2-19.3
                c43.1-10,84.6-38.7,86.3-39.9l-28-27.9c-9.9,6.9-41.7,26.2-70.1,32.8c-41.4,9.6-53.8,36.8-55,51.7c-2,8.3-9.1,43.3,0.4,78.9l1.7,4.7
                l3.3,3.3c0.5,0.5,0.9,1.1,1.4,1.7c16.2,19.6,45.8,41.1,191.5,49.4c1.5,0.3,3.1,0.5,4.7,0.5c0.5,0,1,0,1.4,0c0.2,0,0.5,0,0.7,0
                c0.3,0,0.5,0,0.8,0l0-0.1c161.1-8.9,184.7-35.4,197.4-49.7c0.6-0.6,1-1.2,1.5-1.7l3.8-3.5l1.2-4.6C470.2,416.9,463,381.9,461,373.6z
                "
      />
    </g>
  ),

  info: (
    <g>
      <path d="M256,138.4c-45,0-76.1-31.1-76.1-69.2S211,0,256,0c45,0,76.1,31.1,76.1,69.2S301,138.4,256,138.4z M325.2,512H186.8V173h138.4V512z" />
    </g>
  ),

  question: (
    <g>
      <path
        d="M298.5,169.2c0-20.8-17.3-38.1-45.1-38.1c-38.1,0-59.7,23.6-65.9,41.6l-111-52C93.2,70.1,154.2,2.8,260.3,2.8
                c107.5,0,180.3,72.8,180.3,145.7c0,66.6-43,97.8-82.5,130.4c-20.8,17.3-34.7,31.2-48.6,49.9c-13.2,18-29.8,32.6-59,32.6
                c-33.3,0-53.4-21.5-53.4-49.9c0-24.3,14.6-48.6,39.5-69.4C270.7,213.6,298.5,199.8,298.5,169.2z M249.9,384.3
                c38.1,0,65.9,27.7,65.9,62.4c0,34.7-27.7,62.4-65.9,62.4S184,481.4,184,446.7C184,412,211.8,384.3,249.9,384.3z"
      />
    </g>
  ),

  warning: (
    <g>
      <path d="M256,0C114.6,0,0,114.6,0,256s114.6,256,256,256s256-114.6,256-256S397.4,0,256,0z M256,465.5c-115.7,0-209.5-93.8-209.5-209.5S140.3,46.5,256,46.5S465.5,140.3,465.5,256S371.7,465.5,256,465.5z" />
      <circle cx="258.1" cy="350.9" r="37.3" />
      <path d="M256,298.7c17.7,0,32-14.5,32-32.3V106.7h-64v159.7C224,284.2,238.3,298.7,256,298.7z" />
    </g>
  ),

  medal(value: number) {
    return (
      <g className="medalwrapper-medal">
        <path
          d="M87.7,108.5c1.4,0.9,3.2,0.9,4.6,0l2.8-1.7c0.4-0.2,0.8-0.3,1.2-0.2l3.2,0.5c1.7,0.2,3.3-0.4,4.3-1.8l1.9-2.6
				c0.2-0.3,0.6-0.6,1-0.7l3.2-0.8c1.6-0.4,2.9-1.6,3.3-3.2l0.8-3.2c0.1-0.4,0.4-0.8,0.7-1l2.6-1.9c1.4-1,2-2.6,1.8-4.3l-0.5-3.2
				c-0.1-0.4,0-0.9,0.2-1.2l1.7-2.8c0.9-1.4,0.9-3.2,0-4.6l-1.7-2.8c-0.2-0.4-0.3-0.8-0.2-1.2l0.5-3.2c0.2-1.7-0.4-3.3-1.8-4.3
				l-2.6-1.9c-0.3-0.2-0.6-0.6-0.7-1l-0.8-3.2c-0.4-1.6-1.7-2.9-3.3-3.2l-3.2-0.8c-0.4-0.1-0.8-0.3-1-0.7l-1.9-2.6
				c-1-1.3-2.6-2-4.3-1.8l-3.2,0.5c-0.4,0.1-0.9,0-1.2-0.2l-2.8-1.7c-1.4-0.9-3.2-0.9-4.6,0l-2.8,1.7c-0.4,0.2-0.8,0.3-1.2,0.2
				L80.4,49c-1.7-0.2-3.3,0.4-4.3,1.8l-1.9,2.6c-0.2,0.3-0.6,0.6-1,0.7L70,54.9c-1.6,0.4-2.9,1.6-3.3,3.2l-0.3,1.3l-20.1-9
				c-0.4-0.2-0.9-0.1-1.3,0.1c-0.4,0.3-0.6,0.7-0.5,1.2l0.9,7.2l-6,4.1c-0.3,0.2-0.5,0.6-0.5,1.1c0,0,0,0.1,0,0.1
				c0,0.5,0.3,0.9,0.7,1.1L60,74.5l-0.7,1.2c-0.4,0.7-0.7,1.5-0.7,2.3s0.2,1.6,0.7,2.3l0.7,1.2l-20.6,9.2c-0.4,0.2-0.7,0.6-0.7,1.1
				c0,0,0,0.1,0,0.1c0,0.4,0.2,0.8,0.5,1.1l6,4.1l-0.9,7.2c0,0.5,0.1,0.9,0.5,1.2c0.4,0.3,0.9,0.3,1.3,0.1l20.1-8.8l0.3,1.3
				c0.4,1.6,1.7,2.9,3.3,3.2l3.2,0.8c0.4,0.1,0.8,0.3,1,0.7l1.9,2.6c1,1.3,2.6,2,4.3,1.8l3.2-0.5c0.4-0.1,0.9,0,1.2,0.2L87.7,108.5z
				M42.6,64.1l4.8-3.3c0.4-0.3,0.6-0.7,0.5-1.2l-0.7-5.7L65.6,62c-0.1,0.2-0.2,0.3-0.4,0.4l-2.6,1.9c-0.2,0.2-0.5,0.4-0.7,0.6
				l-9.7-4.3c-0.7-0.3-1.4,0-1.7,0.7c-0.1,0.2-0.1,0.3-0.1,0.5c0,0.5,0.3,1,0.8,1.2l9.6,4.3c0,0.4,0,0.9,0,1.3l0.5,3.2
				c0,0.2,0,0.4,0,0.6L42.6,64.1z M47.2,102.4l0.7-5.7c0-0.5-0.2-1-0.5-1.2l-4.8-3.3l18.6-8.3c0,0.2,0,0.4,0,0.5l-0.5,3.2
				c-0.1,0.5-0.1,0.9,0,1.3l-9.6,4.3c-0.5,0.2-0.8,0.7-0.8,1.2c0,0.2,0,0.4,0.1,0.5c0.3,0.7,1.1,1,1.7,0.7l9.7-4.3
				c0.2,0.2,0.4,0.4,0.7,0.6l2.6,1.9c0.2,0.1,0.3,0.2,0.4,0.5L47.2,102.4z M89,106.3l-2.8-1.7c-0.9-0.5-1.9-0.7-3-0.6l-3.2,0.5
				c-0.7,0.1-1.4-0.2-1.8-0.7l-1.9-2.6c-0.6-0.8-1.5-1.4-2.5-1.7l-3.2-0.8c-0.7-0.2-1.2-0.7-1.4-1.3l-0.8-3.1c-0.2-1-0.9-1.9-1.7-2.5
				l-2.6-1.9c-0.6-0.4-0.8-1.1-0.7-1.7l0.5-3.2c0.2-1,0-2.1-0.6-3l-1.7-2.8c-0.4-0.6-0.4-1.3,0-1.9l1.7-2.8c0.4-0.7,0.7-1.5,0.7-2.3
				c0-0.2,0-0.5,0-0.7l-0.5-3.2c-0.1-0.7,0.2-1.4,0.7-1.7l2.6-1.9c0.9-0.6,1.4-1.5,1.7-2.5l0.8-3.2c0.2-0.7,0.7-1.2,1.4-1.3l3.2-0.8
				c1-0.2,1.9-0.8,2.5-1.7l1.9-2.6c0.4-0.5,1.1-0.8,1.8-0.7l3.2,0.5c1,0.2,2.1,0,3-0.6l2.8-1.7c0.6-0.4,1.3-0.4,1.9,0l2.8,1.7
				c0.9,0.5,1.9,0.7,3,0.6l3.2-0.5c0.7-0.1,1.4,0.2,1.8,0.7l1.9,2.6c0.6,0.8,1.5,1.4,2.5,1.7l3.2,0.8c0.7,0.2,1.2,0.7,1.4,1.3l0.8,3.2
				c0.2,1,0.9,1.9,1.7,2.5l2.6,1.9c0.6,0.4,0.8,1.1,0.7,1.7l-0.5,3.2c-0.2,1,0,2.1,0.6,3l1.7,2.8c0.4,0.6,0.4,1.3,0,1.9l-1.7,2.8
				c-0.5,0.9-0.7,1.9-0.6,3l0.5,3.2c0.1,0.7-0.2,1.4-0.7,1.7l-2.6,1.9c-0.9,0.6-1.4,1.5-1.7,2.5l-0.8,3.2c-0.2,0.7-0.7,1.2-1.4,1.3
				l-3.2,0.8c-1,0.2-1.9,0.8-2.5,1.7l-1.9,2.6c-0.4,0.5-1.1,0.8-1.8,0.7l-3.2-0.5c-1-0.2-2.1,0-3,0.6l-2.8,1.7
			    C90.3,106.7,89.6,106.7,89,106.3z"
        />
        <path
          d="M103.9,63.1c6.4,6.4,8,16,3.9,24.1c-0.3,0.6-0.1,1.4,0.6,1.7c0.7,0.3,1.4,0.1,1.7-0.6c4.6-9,2.9-19.9-4.4-27
				C97.4,53,84,52.2,74.6,59.4c-0.3,0.2-0.5,0.6-0.5,1c0,0.3,0.1,0.5,0.3,0.8c0.5,0.6,1.3,0.7,1.8,0.2C84.5,55,96.4,55.8,103.9,63.1z"
        />
        <path
          d="M100.7,97.4c-0.3-0.7-1.1-0.9-1.7-0.6c-8,4.1-17.7,2.5-24.1-3.9c-7.4-7.4-8.1-19.4-1.7-27.7c0.5-0.6,0.3-1.4-0.2-1.8
			    c-0.6-0.5-1.4-0.3-1.8,0.2c-3.3,4.3-4.9,9.3-4.9,14.4c0,6.1,2.3,12.1,6.8,16.7c7.2,7.2,18,9,27,4.4C100.8,98.8,101.1,98,100.7,97.4
				z"
        />
        <path
          d="M103.9,92.9c-0.3,0.3-0.7,0.6-1,0.9c-0.3,0.2-0.5,0.6-0.5,1c0,0.3,0.1,0.6,0.3,0.9c0.5,0.5,1.3,0.6,1.9,0.1
			    c0.4-0.3,0.7-0.7,1.1-1c0.4-0.4,0.7-0.7,1-1.1c0.5-0.5,0.5-1.4-0.1-1.9c-0.5-0.5-1.4-0.5-1.9,0.1C104.5,92.2,104.2,92.6,103.9,92.9
				z"
        />
        <text className={'medal-total'} x="78" y="-82" textAnchor="middle">
          {value}
        </text>
      </g>
    )
  },

  medalStars: (
    <g className={'medalwrapper-stars'}>
      <path
        className="medal-star_12"
        d="M118.2,45.8c0.5,0.2,1,0.5,1.5,0.6c-0.2,0.5-0.5,1-0.6,1.5c-0.5-0.2-1-0.5-1.5-0.6
                C117.8,46.8,118.1,46.3,118.2,45.8z M114.3,50.2c2-0.9,4.4,0,5.3,2c0.3,0.7,1.1,1,1.8,0.7c0.7-0.3,1-1.1,0.7-1.8
                c-0.9-2,0-4.4,2-5.3c0.7-0.3,1-1.1,0.7-1.8c-0.3-0.7-1.1-1-1.8-0.7c-2,0.9-4.4,0-5.3-2c-0.3-0.7-1.1-1-1.8-0.7
                c-0.7,0.3-1,1.1-0.7,1.8c0.9,2,0,4.4-2,5.3c-0.7,0.3-1,1.1-0.7,1.8C112.9,50.2,113.7,50.6,114.3,50.2z"
      />
      <path
        className="medal-star_11"
        d="M104.3,119.4c0.5,0.2,1,0.5,1.5,0.6c-0.2,0.5-0.5,1-0.6,1.5c-0.5-0.2-1-0.5-1.5-0.6
                C104,120.6,104.2,120,104.3,119.4z M100.5,123.9c2-0.9,4.4,0,5.3,2c0.3,0.7,1.1,1,1.8,0.7c0.7-0.3,1-1.1,0.7-1.8
                c-0.9-2,0-4.4,2-5.3c0.7-0.3,1-1.1,0.7-1.8c-0.3-0.7-1.1-1-1.8-0.7c-2,0.9-4.4,0-5.3-2c-0.3-0.7-1.1-1-1.8-0.7
                c-0.7,0.3-1,1.1-0.7,1.8c0.9,2,0,4.4-2,5.3c-0.7,0.3-1,1.1-0.7,1.8C99,123.9,99.8,124.2,100.5,123.9z"
      />
      <path
        className="medal-star_10"
        d="M127.5,99.1c0.7,0.5,1.4,0.9,2.2,1.2c-0.5,0.7-0.9,1.4-1.2,2.2c-0.7-0.5-1.4-0.9-2.2-1.2
                C126.8,100.6,127.2,99.8,127.5,99.1z M120.8,104.7c3.2-0.9,6.4,1,7.3,4.2c0.3,1,1.4,1.7,2.5,1.4c1-0.3,1.7-1.4,1.4-2.5
                c-0.9-3.2,1-6.4,4.2-7.3c1-0.3,1.7-1.4,1.4-2.5c-0.3-1-1.4-1.7-2.5-1.4c-3.2,0.9-6.4-1-7.3-4.2c-0.3-1-1.4-1.7-2.5-1.4
                c-1,0.3-1.7,1.4-1.4,2.5c0.9,3.2-1,6.4-4.2,7.3c-1,0.3-1.7,1.4-1.4,2.5C118.6,104.4,119.8,105,120.8,104.7z"
      />
      <path
        className="medal-star_9"
        d="M41,36.8c0.8-0.2,1.6-0.6,2.3-1c0.2,0.8,0.6,1.6,1,2.3c-0.8,0.2-1.6,0.6-2.3,1C41.8,38.3,41.4,37.5,41,36.8z
                M41.5,45.6c1.2-3.1,4.7-4.5,7.7-3.3c1,0.4,2.2-0.1,2.6-1.1c0.4-1-0.1-2.2-1.1-2.6c-3.1-1.2-4.5-4.7-3.3-7.7c0.4-1-0.1-2.2-1.1-2.6
                c-1-0.4-2.2,0.1-2.6,1.1c-1.2,3.1-4.7,4.5-7.7,3.3c-1-0.4-2.2,0.1-2.6,1.1c-0.4,1,0.1,2.2,1.1,2.6c3.1,1.2,4.5,4.7,3.3,7.7
                c-0.4,1,0.1,2.2,1.1,2.6C40,47.1,41.1,46.6,41.5,45.6z"
      />
      <path
        className="medal-star_8"
        d="M88.2,26.6c0.7,0.4,1.5,0.7,2.3,0.9c-0.4,0.7-0.7,1.5-0.9,2.3c-0.7-0.4-1.5-0.7-2.3-0.9
                C87.7,28.2,88,27.4,88.2,26.6z M82.4,33.3c3-1.4,6.5,0,7.9,3c0.4,1,1.6,1.5,2.6,1c1-0.4,1.5-1.6,1-2.6c-1.4-3,0-6.5,3-7.9
                c1-0.4,1.5-1.6,1-2.6c-0.4-1-1.6-1.5-2.6-1c-3,1.4-6.5,0-7.9-3c-0.4-1-1.6-1.5-2.6-1c-1,0.4-1.5,1.6-1,2.6c1.4,3,0,6.5-3,7.9
                c-1,0.4-1.5,1.6-1,2.6C80.2,33.3,81.5,33.7,82.4,33.3z"
      />
      <path
        className="medal-star_7"
        d="M139.3,65.1c0.5,0.2,1,0.5,1.5,0.6c-0.2,0.5-0.5,1-0.6,1.5c-0.5-0.2-1-0.5-1.5-0.6
                C138.9,66.2,139.2,65.7,139.3,65.1z M135.4,69.6c2-0.9,4.4,0,5.3,2c0.3,0.7,1.1,1,1.8,0.7c0.7-0.3,1-1.1,0.7-1.8
                c-0.9-2,0-4.4,2-5.3c0.7-0.3,1-1.1,0.7-1.8c-0.3-0.7-1.1-1-1.8-0.7c-2,0.9-4.4,0-5.3-2c-0.3-0.7-1.1-1-1.8-0.7
                c-0.7,0.3-1,1.1-0.7,1.8c0.9,2,0,4.4-2,5.3c-0.7,0.3-1,1.1-0.7,1.8C134,69.6,134.8,69.9,135.4,69.6z"
      />
      <path
        className="medal-star_6"
        d="M39.7,114.8c0.9,0.1,1.6-0.1,2.5-0.3c-0.1,0.9,0.1,1.6,0.3,2.5c-0.9-0.1-1.6,0.1-2.5,0.3
                C39.9,116.4,39.9,115.6,39.7,114.8z M37.5,123.3c2.1-2.6,5.8-2.9,8.4-0.8c0.8,0.7,2.1,0.6,2.8-0.3c0.7-0.8,0.6-2.1-0.3-2.8
                c-2.6-2.1-2.9-5.8-0.8-8.4c0.7-0.8,0.6-2.1-0.3-2.8c-0.8-0.7-2.1-0.6-2.8,0.3c-2.1,2.6-5.8,2.9-8.4,0.8c-0.8-0.7-2.1-0.6-2.8,0.3
                c-0.7,0.8-0.6,2.1,0.3,2.8c2.6,2.1,2.9,5.8,0.8,8.4c-0.7,0.8-0.6,2.1,0.3,2.8C35.5,124.3,36.8,124.1,37.5,123.3z"
      />
      <path
        className="medal-star_5"
        d="M20.5,74.5c0,0.6,0.1,1.1,0.3,1.7c-0.6,0-1.1,0.1-1.7,0.3c0-0.6-0.1-1.1-0.3-1.7
                C19.4,74.8,19.9,74.7,20.5,74.5z M14.6,73.7c1.8,1.2,2.3,3.8,1.1,5.6c-0.4,0.6-0.2,1.5,0.4,1.8c0.6,0.4,1.5,0.2,1.8-0.4
                c1.2-1.8,3.8-2.3,5.6-1.1c0.6,0.4,1.5,0.2,1.8-0.4c0.4-0.6,0.2-1.5-0.4-1.8c-1.8-1.2-2.3-3.8-1.1-5.6c0.4-0.6,0.2-1.5-0.4-1.8
                c-0.6-0.4-1.5-0.2-1.8,0.4c-1.2,1.8-3.8,2.3-5.6,1.1c-0.6-0.4-1.5-0.2-1.8,0.4C13.8,72.4,14,73.2,14.6,73.7z"
      />
      <path
        className="medal-star_4"
        d="M79.7,135.5c0.6,0.1,1.1,0,1.7-0.1c-0.1,0.6,0,1.1,0.1,1.7c-0.6-0.1-1.1,0-1.7,0.1
                C79.9,136.6,79.8,136.1,79.7,135.5z M78.1,141.3c1.4-1.7,3.9-1.9,5.7-0.5c0.6,0.5,1.4,0.4,1.9-0.2c0.5-0.6,0.4-1.4-0.2-1.9
                c-1.7-1.4-1.9-3.9-0.5-5.7c0.5-0.6,0.4-1.4-0.2-1.9c-0.6-0.5-1.4-0.4-1.9,0.2c-1.4,1.7-3.9,1.9-5.7,0.5c-0.6-0.5-1.4-0.4-1.9,0.2
                c-0.5,0.6-0.4,1.4,0.2,1.9c1.7,1.4,1.9,3.9,0.5,5.7c-0.5,0.6-0.4,1.4,0.2,1.9C76.8,141.9,77.6,141.8,78.1,141.3z"
      />
      <path
        className="medal-star_3"
        d="M69.3,47.3c0.2,0.3,0.3,0.5,0.5,0.7c-0.3,0.2-0.5,0.3-0.7,0.5c-0.2-0.3-0.3-0.5-0.5-0.7
                C68.8,47.7,69.1,47.5,69.3,47.3z M66.2,48.2c1.2,0.2,2,1.3,1.8,2.5c-0.1,0.4,0.2,0.8,0.6,0.8s0.8-0.2,0.8-0.6
                c0.2-1.2,1.3-2,2.5-1.8c0.4,0.1,0.8-0.2,0.8-0.6c0.1-0.4-0.2-0.8-0.6-0.8c-1.2-0.2-2-1.3-1.8-2.5c0.1-0.4-0.2-0.8-0.6-0.8
                c-0.4-0.1-0.8,0.2-0.8,0.6c-0.2,1.2-1.3,2-2.5,1.8c-0.4-0.1-0.8,0.2-0.8,0.6C65.5,47.8,65.8,48.2,66.2,48.2z"
      />
      <path
        className="medal-star_2"
        d="M73.2,118.8c0.2,0.3,0.3,0.5,0.5,0.7c-0.3,0.2-0.5,0.3-0.7,0.5c-0.2-0.3-0.3-0.5-0.5-0.7
                C72.8,119.2,73,119,73.2,118.8z M70.1,119.8c1.2,0.2,2,1.3,1.8,2.5c-0.1,0.4,0.2,0.8,0.6,0.8c0.4,0.1,0.8-0.2,0.8-0.6
                c0.2-1.2,1.3-2,2.5-1.8c0.4,0.1,0.8-0.2,0.8-0.6c0.1-0.4-0.2-0.8-0.6-0.8c-1.2-0.2-2-1.3-1.8-2.5c0.1-0.4-0.2-0.8-0.6-0.8
                c-0.4-0.1-0.8,0.2-0.8,0.6c-0.2,1.2-1.3,2-2.5,1.8c-0.4-0.1-0.8,0.2-0.8,0.6S69.7,119.7,70.1,119.8z"
      />
      <path
        className="medal-star_1"
        d="M129.1,81c-0.1,0.2-0.2,0.4-0.2,0.6c-0.2-0.1-0.4-0.2-0.6-0.2c0.1-0.2,0.2-0.4,0.2-0.6
                C128.7,80.8,128.9,80.9,129.1,81z M127.4,79.5c0.4,0.8,0.1,1.7-0.7,2.1c-0.3,0.1-0.4,0.4-0.2,0.7c0.1,0.3,0.4,0.4,0.7,0.2
                c0.8-0.4,1.7-0.1,2.1,0.7c0.1,0.3,0.4,0.4,0.7,0.2c0.3-0.1,0.4-0.4,0.2-0.7c-0.4-0.8-0.1-1.7,0.7-2.1c0.3-0.1,0.4-0.4,0.2-0.7
            c-0.1-0.3-0.4-0.4-0.7-0.2c-0.8,0.4-1.7,0.1-2.1-0.7c-0.1-0.3-0.4-0.4-0.7-0.2S127.2,79.3,127.4,79.5z"
      />
    </g>
  ),

  triangleWarning: (
    <g id="Page-1">
      <g transform="translate(-577.000000, -501.000000)">
        <g transform="translate(517.000000, 445.000000)">
          <g transform="translate(60.000000, 56.000000)">
            <path
              d="M250.17,330.75c-11.4,0-20.96,9.45-20.96,20.72c0,11.27,9.56,20.72,20.96,20.72
					c10.98,0,20.96-9.45,20.46-20.22C271.13,340.11,261.66,330.75,250.17,330.75z"
            />
            <path
              d="M486.47,431.09c16.05-27.78,16.15-60.89,0.2-88.56L326.59,64.54c-15.84-27.98-44.47-44.59-76.57-44.59
					s-60.72,16.71-76.57,44.49L13.17,342.74c-15.95,27.98-15.84,61.3,0.31,89.08c15.95,27.47,44.47,43.97,76.36,43.97H409.6
					C441.59,475.79,470.32,459.08,486.47,431.09z M450.5,410.01c-8.84,15.28-24.48,24.34-41.96,24.34H90.78
					c-17.27,0-32.81-8.86-41.45-23.83c-8.74-15.17-8.84-33.3-0.1-48.58L208.52,85.53c8.63-15.17,24.08-24.14,41.55-24.14
					c17.37,0,32.91,9.06,41.55,24.24L450.8,362.04C459.34,376.91,459.24,394.83,450.5,410.01z"
            />
            <path
              d="M245.05,145c-9.77,3.54-15.84,14.79-15.84,28.44c0.49,8.23,0.9,16.56,1.39,24.8
					c1.4,31.36,2.79,62.09,4.19,93.45c0.49,10.63,6.98,18.34,15.35,18.34s14.93-8.23,15.35-18.96c0-6.46,0-12.4,0.49-18.96
					c0.9-20.11,1.89-40.21,2.79-60.32c0.49-13.02,1.4-26.05,1.89-39.07c0-4.69-0.49-8.86-1.89-13.02
					C264.58,148.03,254.81,142.09,245.05,145z"
            />
          </g>
        </g>
      </g>
    </g>
  ),

  ovalCheck: (
    <g clipRule="evenodd" fillRule="evenodd" transform="translate(3 3)">
      <circle
        cx="246.91"
        cy="247.1"
        fill="#222"
        r="250.1"
        stroke="#222"
        strokeWidth="2.5"
      />
      <path
        d="m353.17 172.6c-8.58.01-16.64 2.98-22.68 8.39l-114.83 95.59-61.73-85.39-45.37 40.43 107.08 132.54 25.53-22.74c.03-.03 44.93-40.03 134.68-120 6.07-5.4 9.41-12.58 9.41-20.21 0-7.65-3.34-14.83-9.4-20.21-6.05-5.42-14.11-8.4-22.69-8.4z"
        style={{ color: 'white' }}
      />
    </g>
  ),

  airplane: (
    <g id="verzekering" fill="#222222" fillRule="nonzero">
      <path
        d="M211.943188,357.621764 C213.600305,358.306182 215.056558,358.941712 216.563027,359.528356 C225.601842,363.097105 234.891735,365.932549 244.432706,367.936915 C260.1502,371.261229 276.068557,372.53229 292.187777,371.750098 C300.423141,371.310116 308.60829,370.381263 316.693008,368.865767 C325.53096,367.252497 334.16805,364.95481 342.604277,362.021591 C356.865518,357.084007 370.222877,350.435379 382.676355,342.075707 C395.481343,333.520488 406.980724,323.498659 417.124283,312.059108 C429.276467,298.370756 438.968085,283.166908 446.199137,266.496451 C450.316819,256.963492 453.53062,247.137211 455.840539,237.066495 C458.501968,225.431396 459.85779,213.649636 460.008437,201.770102 C460.108868,192.970448 459.556496,184.21968 458.351321,175.468912 C457.949596,172.535694 457.347008,169.602476 456.794636,166.718145 C456.694205,166.131501 456.643989,165.544857 456.493342,164.909327 C456.342695,164.127135 456.593773,163.491604 457.196361,162.953848 C459.255202,161.193917 473.918168,148.678852 474.922481,147.75 C477.383047,151.318749 482.002886,179.086548 482.354395,191.454952 C482.806336,206.267704 481.852239,220.982682 479.040163,235.599886 C476.228088,250.119316 471.809112,264.149877 465.682804,277.64268 C459.556496,291.233258 451.923719,303.94387 442.784473,315.823404 C424.254903,339.826907 401.306357,358.795051 373.838403,372.53229 C346.470881,386.220642 317.345811,393.260365 286.563626,393.798122 C255.731224,394.335879 226.355076,388.17612 198.23432,375.514395 C197.832594,376.003265 197.430869,376.492135 197.07936,376.932117 C193.915775,381.08751 190.75219,385.242902 187.588604,389.349408 C187.136664,389.984938 186.634507,390.571582 186.132351,391.158226 C182.165316,395.460279 174.63297,395.020296 171.921326,388.860538 C169.460759,383.238536 166.899762,377.714309 164.338764,372.141194 C159.116338,360.75053 153.944127,349.359866 148.721701,337.969202 C148.119113,336.600367 147.566741,335.182645 147.717388,333.667148 C147.968467,330.000626 150.931189,327.409616 154.898225,327.458503 C158.011594,327.50739 161.074748,327.702938 164.188117,327.898486 C175.737714,328.48513 187.287311,329.12066 198.836907,329.707304 C204.511274,330.000626 210.235857,330.196174 215.910224,330.440608 C222.337825,330.685043 226.003567,336.649254 223.191491,342.320142 C222.739551,343.248995 222.086747,344.12896 221.48416,344.960039 C218.672084,348.675448 215.860008,352.390858 213.047933,356.106268 C212.646207,356.595138 212.344914,357.03512 211.943188,357.621764 Z"
        id="Path"
      ></path>
      <path
        d="M391.394774,187.15 C391.037672,186.834839 390.680569,186.624731 390.425496,186.30957 C365.377325,154.845985 340.278139,123.329874 315.076923,91.7087081 C325.738976,82.0437672 336.350014,72.4838799 347.16511,62.7138853 C361.857317,83.3044117 376.447494,103.789884 391.139701,124.432938 C392.313037,123.434927 393.384344,122.647025 394.353621,121.806595 C399.455082,117.499393 404.505528,113.192191 409.606988,108.884989 C413.739171,105.418217 417.871354,101.951444 421.952523,98.4846722 C426.135721,94.965373 430.267904,91.4460739 434.451101,87.9267747 C438.583285,84.4600024 442.715468,80.9932301 446.796636,77.473931 C450.979834,73.9546318 455.112017,70.4353327 459.2442,66.9160335 C462.407106,64.237164 465.518997,61.6108214 468.681902,58.9844787 C470.416399,57.5137268 472.099881,56.042975 473.885392,54.6247499 C478.62975,50.7902897 484.037299,49.0569035 490.057022,49.2670109 C495.770658,49.4771183 500.821104,51.3155582 505.157346,55.0974916 C509.08547,58.5117371 511.279098,62.8714659 511.891274,68.0190974 C512.40142,72.4313531 511.07504,76.4233939 508.779383,80.1002736 C507.555032,82.0437672 505.973579,83.6195728 504.239083,85.1428515 C499.188637,89.607634 494.24022,94.1774702 489.240789,98.6947796 C484.394401,103.107035 479.496999,107.466764 474.650611,111.87902 C467.304508,118.54993 459.958405,125.22084 452.612301,131.891751 C448.072001,135.988845 443.531701,140.033413 438.991401,144.077981 C432.0024,150.381203 425.064414,156.684425 418.075413,162.987648 C411.596558,168.818128 405.168718,174.648609 398.689863,180.47909 C396.649278,182.31753 394.659709,184.155969 392.670139,185.994409 C392.364051,186.414624 391.90492,186.782312 391.394774,187.15 Z"
        id="Path"
      ></path>
      <path
        d="M423.384615,64.7509711 C420.338016,67.084202 417.541137,69.417433 414.694314,71.7506639 C411.897436,74.0342517 409.000669,76.2681962 406.20379,78.8 C405.754292,78.4028543 405.354738,78.0057086 405.005128,77.6085629 C388.37369,59.8859363 368.995318,46.0354802 346.670234,36.2557675 C337.430546,32.1850241 327.891193,29.0078585 318.052174,26.6249844 C307.863545,24.1428238 297.475139,22.6038842 286.986845,21.9088793 C286.537347,21.859236 286.137793,21.7599496 285.538462,21.6606632 C286.737124,14.4127543 287.885842,7.26413177 288.984615,0.214795693 C295.077815,-1.32414387 328.890078,5.7251922 343.723523,11.1859455 C374.639019,22.6038842 401.109476,40.3761541 423.384615,64.7509711 Z"
        id="Path"
      ></path>
      <path
        d="M225.708367,108.35 L203.831076,112.843909 L233.816733,262.899152 L233.816733,263.467348 C233.816733,264.707047 233.102789,265.791783 231.980876,266.308325 C231.623904,266.411633 231.266932,266.514941 230.90996,266.514941 C230.349004,266.514941 229.839044,266.359979 229.38008,266.101708 C228.921116,265.791783 228.513147,265.37855 228.258167,264.862009 L171.754582,151.377889 L96.9944223,227.102841 L105.969721,279.066894 L105.969721,279.583436 C105.969721,280.409902 105.663745,281.184714 105.102789,281.752909 C104.796813,282.062834 104.490837,282.26945 104.082869,282.424413 C103.725896,282.579375 103.368924,282.631029 103.011952,282.631029 C102.450996,282.631029 101.89004,282.476067 101.431076,282.166142 C100.921116,281.856217 100.564143,281.442984 100.309163,280.926443 L75.1171315,229.375623 L24.2741036,205.253145 C23.6621514,204.94322 23.1011952,204.478333 22.7442231,203.910138 C22.387251,203.290288 22.1832669,202.618784 22.2342629,201.947281 C22.2342629,201.482394 22.336255,201.017506 22.489243,200.604273 C22.6932271,200.139386 22.9482072,199.726153 23.3051793,199.364574 C23.9681275,198.693071 24.8860558,198.279838 25.8549801,198.279838 L26.5179283,198.279838 L26.5179283,198.279838 L77.5649402,207.31931 L115.2,169.095255 C119.789641,164.911271 120.095618,157.783001 115.96494,153.134129 C111.834263,148.485258 104.796813,148.175333 100.207171,152.359317 C99.9521912,152.617588 99.6972112,152.875859 99.4422311,153.134129 L69.9665339,183.04187 L30.3936255,176.016908 L30.3936255,176.016908 C28.914741,175.758638 27.3848606,175.603675 25.9059761,175.603675 C11.5760956,175.603675 0,187.380816 0,201.895627 C0,212.07149 5.81354582,221.317579 14.9418327,225.656526 L58.6454183,246.369831 L80.4717131,290.947344 C82.6135458,295.389599 85.9282869,299.108696 90.1099602,301.639749 C102.094024,308.974635 117.647809,305.100575 124.940239,292.961855 C128.101992,287.64148 129.2749,281.339676 128.203984,275.192835 L121.064542,234.747652 L165.686056,189.55029 L208.216733,275.089527 C212.449402,283.76742 221.220717,289.242758 230.756972,289.191104 C233.969721,289.191104 237.18247,288.571254 240.191235,287.331555 C249.72749,283.405841 256,274.056444 256,263.62231 C256,261.917724 255.847012,260.213138 255.49004,258.560205 L225.708367,108.35 Z"
        id="Path"
      ></path>
      <path
        d="M256.727555,33.4195227 C243.349319,26.4362684 227.177825,29.0676396 216.543842,39.9979506 L174.595966,83.2637648 L48.6543277,56.5958302 L48.6543277,56.5958302 C47.0861828,56.2416071 45.5180379,56.0897972 43.949893,56.0897972 C34.0509782,56.039194 25.1321541,62.2633988 21.4568144,71.7262143 C20.2807057,74.7118085 19.6923077,77.8492126 19.6923077,81.0878233 C19.6436469,90.6012421 24.8381269,99.2544049 33.0708877,103.454478 L136.911483,157.6 L146.467366,137.965923 L146.467366,137.965923 L42.5777662,83.7191944 C42.0877209,83.466178 41.6956847,83.1119549 41.4016575,82.6565253 C41.1566348,82.2010957 41.0096213,81.6444595 41.0096213,81.0878233 C41.0096213,80.7336002 41.0586258,80.3793772 41.2056394,80.0251541 C41.6466801,78.9118817 42.7247797,78.2034356 43.9008884,78.2034356 L44.4399382,78.2034356 L44.4399382,78.2034356 L181.652618,107.249725 L231.490223,55.6343676 C233.989454,53.0535998 237.370766,51.6367076 240.899093,51.6873109 C243.006287,51.6873109 245.113482,52.1933438 246.975654,53.2054096 C248.935835,54.2174755 250.601989,55.7355742 251.876107,57.607896 C253.346243,59.7838375 254.081311,62.3140021 254.081311,64.9453733 C254.032306,68.9430333 252.513166,72.7382802 249.768912,75.5720645 L231.294205,94.9531251 C227.226829,99.4062148 227.373843,106.389469 231.686241,110.589542 C235.802622,114.637806 242.320224,114.637806 246.436604,110.589542 L264.960316,91.2084816 C271.771945,84.2758306 275.643303,74.8130151 275.692308,64.9453733 C275.692308,57.8103092 273.585113,50.8270549 269.664751,44.9570731 C266.381447,40.0991571 261.922035,36.1521004 256.727555,33.4195227 Z"
        id="Path"
      ></path>
    </g>
  ),

  medalAssets(pixel?: number) {
    const style: React.CSSProperties = { strokeDashoffset: `${pixel}px` }
    return (
      <g className={'medalwrapper-assets'}>
        <circle className={'medal-border'} cx="80" cy="80" r="75.5" />
        {pixel !== undefined ? (
          <circle
            className={'medal-linecounter'}
            cx="80"
            cy="80"
            r="71"
            style={style}
          />
        ) : (
          <circle className={'medal-linecounter'} cx="80" cy="80" r="71" />
        )}
        <rect
          className={'medal-corner'}
          id="corner"
          x="146"
          y="75"
          width="10"
          height="5"
        />
      </g>
    )
  },
}
